import DoAPICall from './DoAPICall'

//Create Dashboard
    export async function createClientDashboardSnippet(userToken, dashboard){
            const apiPayload = {
                httpMethod:'post',
                userToken,
                uri:'clientdashboardsnippets',
                payLoad:{
                    dashboard_snippet_id:dashboard.dashboard_snippet_id,
                    dashboard_id:dashboard.dashboard_id,
                    sizeOnPage:dashboard.sizeOnPage,
                    rowNumber:dashboard.rowNumber,
                    columnNumber:dashboard.columnNumber,
                    hyperlink:dashboard.hyperlink,
                    viewHandler:dashboard.viewHandler,
                    isActive:dashboard.isActive
                },
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

//Get All dashboard
    export async function getClientDashboardSnippets(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientdashboardsnippets',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Dashboards of Client
    export async function getSnippetsofDashboard(userToken,dashboard_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'snippetsofdashboard/'+dashboard_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get One Dashboard
    export async function getClientDashboardSnippet(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientdashboardsnippets/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update Dashboard
    export async function updateClientDashboardSnippet(userToken, dashboard){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clientdashboardsnippets/'+dashboard.id,
            payLoad:{
                sizeOnPage:dashboard.sizeOnPage,
                rowNumber:dashboard.rowNumber,
                columnNumber:dashboard.columnNumber,
                hyperlink:dashboard.hyperlink,
                viewHandler:dashboard.viewHandler,
                isActive:dashboard.isActive
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete dashboard
    export async function deleteClientDashboardSnippet(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'clientdashboardsnippets/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }




